import { Home } from "../components/Home/Home";
import {About} from '../components/AboutMe/About';
import {Project} from '../components/Project/Project';
import {Contact} from '../components/ContactMe/Contact'
import Resume from '../components/Resume/Resume'


export const TOTAL_SCREENS = [
    {
        screen_name: "Home",
        compoonent: Home,
    },
    {
        screen_name: "AboutMe",
        compoonent: About,
    },
    {
        screen_name:"Skills",
        compoonent: Resume,
    },
    {
        screen_name:"Project",
        compoonent: Project,
    },
    {
        screen_name:"ContactMe",
        compoonent: Contact,
    },
]

export const GET_SCREENS_INDEX = (screen_name) => {
    if (!screen_name) return -1

    for (let i = 0; i < TOTAL_SCREENS.length; i++) {
        if (TOTAL_SCREENS[i].screen_name === screen_name) return i;       
    }
    return -1;
}